/*
 * @Description: 页面说明 接口axios
 * @Version: 版本号
 * @Author: chuzhangyi
 * @Date: 2022-06-23 09:51:58
 * @LastEditors: 最后一次编辑说明
 * @LastEditTime: 2024-08-07 09:20:43
 * @FilePath: \买家e:\LBB\wechat_business\src\api\index.js
 */
import Vue from 'vue';
import axios from 'axios';
import { Notify, Dialog, Toast } from 'vant';
import * as Sentry from '@sentry/vue';
import url from './requestUrl.js'
import { getPartnerOpenid } from '@/utils/partner/auth'
import { isPartnerRoute } from '@/utils/partner/constants'
import { isWxWork } from '@/utils/index'
import {
  buildHttpBreadcrumb,
  sanitizeForSentry,
  shouldReportSentry,
} from '@/utils/sentryNetwork';
// import QS from 'qs';
//网络监测
const EventUtil = {
  addHandler: function (element, type, handler) {
    if (element.addEventListener) {
      element.addEventListener(type, handler, false)
    } else if (element.attachEvent) {
      element.attachEvent("on" + type, handler)
    } else {
      element["on" + type] = handler
    }
  }
}
EventUtil.addHandler(window, "online", () => {
  Notify({
    type: 'success',
    message: '已连接到网络',
  });
})
EventUtil.addHandler(window, "offline", () => {
  Dialog.alert({
    message: '无网络连接',
    className: 'win-pop-box'
  })
})
const service = axios.create({
  timeout: 20000,
});
//防止重复提交ajax
let CancelToken = axios.CancelToken

let sources = []
// 定义取消操作
let removeSource = (config1) => {
  for (let source in sources) {
    // 当多次请求相同时，取消之前的请求
    const config2 = sources[source].config;
    if (config1.method == config2.method && config1.url == config2.url && JSON.stringify(config1.data) === JSON.stringify(config2.data) && config2.url.indexOf('getHandoverList') == -1 && (config2.params || {}).isCancel != 1) {
      sources[source].cancel("cancel")
      sources.splice(source, 1)
    }
  }
}
//标识码
function guid() {
  function crack() {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
  }
  return (crack() + crack() + crack() + crack())
}



function objectToQueryString(obj) {
  let queryStr = '';
  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      queryStr += key + '=' + encodeURIComponent(obj[key]) + '&';
    }
  }
  return queryStr.slice(0, -1); // 移除末尾的"&"字符
}

// 请求之前的拦截器
service.interceptors.request.use(config => {


  if(['getBlockMoneyDetailQW'].includes(config.url)){
    config.isHideErrorMsg = 1
  }

  // log(config)
  const apiKey = config.url
  config._sentryApiKey = apiKey;
  config.url = url[apiKey] ? `${url[apiKey]}` : config.url;
  // config.url += `?${objectToQueryString(config.params)}`
  // v8.8.7
  config.headers.qwSource = 1

  // 企业微信进入友商小程序
  if (isPartnerRoute(window.location.pathname) && isWxWork()) {
    config.headers.source = 10
  }

  if (apiKey && apiKey.startsWith('partner') && apiKey !== 'partnerWxLogin') {
    const openid = getPartnerOpenid()
    if (openid) {
      config.headers.openid = openid
    }
  }

  removeSource(config)
  if(!config.noCancel){
    config.cancelToken = new CancelToken((c) => {
      // 将取消函数存起来
      sources.push({ config, cancel: c })
    })
  }

  // config.url = config.url.indexOf("?") >= 0 ? config.url + "&timestamp=" + guid() : config.url + "?timestamp=" + guid()
  return config
}, error => {
  log('error', error);
  return Promise.reject(error)
})

//  请求之后异常状态拦截
service.interceptors.response.use(
  response => {
    removeSource(response.config)
    const data = response.data;
    if (shouldReportSentry() && typeof Sentry.addBreadcrumb === 'function') {
      const businessCode = data && typeof data === 'object' ? data.code : undefined;
      Sentry.addBreadcrumb(
        buildHttpBreadcrumb(response.config, data, {
          level: businessCode != null && businessCode != 200 ? 'warning' : 'info',
          status: response.status,
        })
      );
    }
    return data;
  },
  error => {
    console.log(error)
    // log(error, error.response, axios.isCancel(error));
    $load.close();
    if (axios.isCancel(error)) {
      // 请求被取消，不上报
      return Promise.resolve({ code: "200", msg: "cancel", ret: '' })
    } else {
      if (error) {
        if (shouldReportSentry() && Sentry && typeof Sentry.captureException === 'function') {
          const cfg = error.config || {};
          const method = (cfg.method || 'get').toUpperCase();
          const apiKey = cfg._sentryApiKey || cfg.url || 'unknown';
          const status = error.response?.status;

          if (typeof Sentry.addBreadcrumb === 'function') {
            Sentry.addBreadcrumb(
              buildHttpBreadcrumb(cfg, error.response?.data, {
                level: 'error',
                status,
              })
            );
          }

          const sentryError = new Error(
            `接口错误: ${method} ${apiKey} - ${status || 'Network Error'}`
          );
          sentryError.name = 'ApiRequestError';

          Sentry.captureException(sentryError, {
            tags: {
              errorType: 'api_error',
              httpMethod: method,
              httpStatus: status || 'network_error',
              apiKey,
              apiUrl: cfg.url,
            },
            extra: {
              apiKey,
              request: {
                url: cfg.url,
                method: cfg.method,
                params: sanitizeForSentry(cfg.params),
                data: sanitizeForSentry(cfg.data),
              },
              response: error.response
                ? {
                    status: error.response.status,
                    statusText: error.response.statusText,
                    data: sanitizeForSentry(error.response.data),
                  }
                : null,
            },
          });
        }

        if (!error.config?.isHideErrorMsg) {
          const errMsg = error.response?.data?.message || error.response?.data?.msg || '加载失败'
          Toast({
            message: errMsg,
            position: 'center',
            // 含数值的长文案居中难读，左对齐
            className: /\d/.test(String(errMsg)) ? 'toast-text-left' : undefined,
          });
        }
        return Promise.reject(error.response?.data || {});
      } else {
        return Promise.reject({});
      }
    }
  }
)
window['$http'] = service;
Vue.prototype.$http = service;
